export interface SilentReauthState {
  isAuthenticated: boolean;
}

type SilentReauthHandler = () => Promise<SilentReauthState | null>;

let silentReauthHandler: SilentReauthHandler | null = null;

export function registerSilentReauthHandler(handler: SilentReauthHandler): () => void {
  silentReauthHandler = handler;
  return () => {
    if (silentReauthHandler === handler) {
      silentReauthHandler = null;
    }
  };
}

export async function reauthSilently(): Promise<SilentReauthState | null> {
  if (!silentReauthHandler) {
    return null;
  }

  return silentReauthHandler();
}
